"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluatePermissions = void 0;
var react_1 = require("react");
var PermissionContext_1 = __importDefault(require("./PermissionContext"));
function usePermission(service, type, field) {
    var _this = this;
    var permissions = (0, react_1.useContext)(PermissionContext_1.default).permissions;
    var _a = (0, react_1.useState)([]), permissionData = _a[0], setPermissionData = _a[1];
    var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(), error = _c[0], setError = _c[1];
    if (typeof service !== 'string') {
        type = service.type;
        field = service.field;
        service = service.service;
    }
    (0, react_1.useEffect)(function () {
        var asyncFetch = function () { return __awaiter(_this, void 0, void 0, function () {
            var contextPermissions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, permissions()];
                    case 1:
                        contextPermissions = _a.sent();
                        setPermissionData(contextPermissions);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        setError(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        asyncFetch();
    }, [permissions]);
    return [
        evaluatePermissions({ service: service, type: type !== null && type !== void 0 ? type : '*', field: field !== null && field !== void 0 ? field : '*' }, permissionData),
        { loading: false, error: false },
    ];
}
function evaluatePermissions(_a, permissions) {
    var service = _a.service, field = _a.field, type = _a.type;
    var compareService = service.toLowerCase();
    var compareField = field.toLowerCase();
    var compareType = type.toLowerCase();
    permissions = permissions.map(function (_a) {
        var service = _a.service, type = _a.type, field = _a.field, grant = _a.grant;
        return ({
            service: service.toLowerCase(),
            type: type.toLowerCase(),
            field: field.toLowerCase(),
            grant: grant,
        });
    });
    var hasAccess = permissions.find(function (_a) {
        var service = _a.service, type = _a.type, field = _a.field, grant = _a.grant;
        if (grant === 'DENY')
            return false;
        var hasService = service === compareService;
        var hasType = compareType === '*' || compareType === type || type === '*';
        var hasField = compareField === '*' || compareField === field || field === '*';
        return hasService && hasType && hasField;
    }) !== undefined;
    var hasNoDeny = permissions.find(function (_a) {
        var service = _a.service, type = _a.type, field = _a.field, grant = _a.grant;
        var hasService = service === compareService;
        var hasType = compareType === '*' || compareType === type || type === '*';
        var hasField = compareField === '*' || compareField === field || field === '*';
        return hasService && hasType && hasField && grant === 'DENY';
    }) === undefined;
    return hasAccess && hasNoDeny;
}
exports.evaluatePermissions = evaluatePermissions;
exports.default = usePermission;
//# sourceMappingURL=usePermission.js.map